import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AlertifyService } from 'src/app/_services/alertify.service';
import { HomeService } from 'src/app/_services/home.service';
import { UtilityService } from 'src/app/_services/utility.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { PublicationsService } from 'src/app/_services/publications.services';
import * as _ from 'lodash';
import { Resources } from 'src/app/_models/publications';

@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.css']
})
export class ResourcesComponent implements OnInit {
  platformId: any;
  CurrentTags: any;
  resourcesList: Array<Resources> = [];

  constructor(private alertifyService: AlertifyService,
    public utilityService: UtilityService,
    public authService: AuthenticationService,
    private route: Router,
    private homeService: HomeService,
    private publicationsService: PublicationsService,
    private titleService: Title, private metaTagService: Meta,
    @Inject(PLATFORM_ID) platformId: any) {
    this.platformId = platformId;
    this.setSEOTags();
  }

  ngOnInit(): void {
    this.homeService.setRouterUrl(this.route.url);
    this.authService.setCurrentFeatureCode("RESO");
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
    this.getResourcesList();
    // if (this.authService.isCookie()) {
    //   this.authService.cookieTracking("RESO").subscribe();
    // }

    if (this.authService.isOneTrustCookie()) {
      this.authService.cookieTracking("RESO").subscribe();
    }
  }

  getResourcesList(): void {
    let selectedProfile = this.utilityService.getSelectedProfile();
    let selectedProfileId = selectedProfile.PK_ENV_PROFILE_ID ?? "";

    this.publicationsService.getResourcesList(selectedProfileId).subscribe((next) => {
      if(next && next.length > 0) {
        this.resourcesList = next;
        this.resourcesList = _.sortBy(this.resourcesList, (resource) => (resource.Resource_Name));
      } else {
        this.resourcesList = [];
      }
    }, (error) => {
      console.log(error);
    })
  }

  openConfirmationPopup(resource: Resources)
  {
    let redirectURL: string = resource.Resource_Link ?? '';
    let title = "You are about to leave "+this.utilityService.getPortalName()+"'s Medical Information Portal";
    let message = "";
    let message1 = "";
    if(resource.Link_Source == "EL_ML"){
      message = "You are leaving " + location.hostname;
      message1 = "If you continue, you will be taken to a website that is owned by a third-party, but maintained on behalf of Mallinckrodt."
    } else if(resource.Link_Source == "EL_NML") {
      message = "You are leaving " + location.hostname;
      message1 = "Links to sites outside of Mallinckrodt Medical Information are provided as a resource to the user. If you continue, you will be taken to a third-party website that is neither owned nor controlled by Mallinckrodt. Mallinckrodt does not endorse or take responsibility for the content or services on this third-party website.";
    } else {
      message = "You are leaving " + location.hostname;
      message1 = "If you continue, you will be taken to a separate site maintained by Mallinckrodt.";
    }
    this.alertifyService.ExternalLinkConfirmationBanner(title, message, redirectURL, this.ConfimationCallBack, "Continue", message1); 
  }

  ConfimationCallBack = (result: any, url: any) => {
    if (result) {
      if (isPlatformBrowser(this.platformId)) {
        window.open(url, "_blank");
      }
    }
  }


  setSEOTags() {
    this.CurrentTags = this.utilityService.getCurrentPageTags("RESO");
    let title = "";
    (this.CurrentTags == undefined || (this.CurrentTags?.Title == "")) ? title = "Resources" : title = this.CurrentTags.Title;
    this.titleService.setTitle(title);
    if (this.CurrentTags != null && this.CurrentTags != undefined) {
      this.metaTagService.updateTag({ name: 'description', content: this.CurrentTags.MetaDescription });
      this.metaTagService.updateTag({ name: 'title', content: this.CurrentTags.MetaTitle });
    }
    else {
      this.metaTagService.updateTag({ name: 'title', content: "" });
      this.metaTagService.updateTag({ name: 'description', content: "" });
    }
  }

}
